import React from 'react';
import { isNewUIEnabled } from 'hooks/useNewUI';
import AddAlbumModalNew from './AddAlbumModalNew';
import AddAlbumModalClassic from './AddAlbumModalClassic';

// The dark create-album modal restyle ships only to allow-listed new-UI users.
// Classic (production) users keep the legacy modal.
const AddAlbumModal = (props) => (isNewUIEnabled()
  ? <AddAlbumModalNew {...props} />
  : <AddAlbumModalClassic {...props} />);

export default AddAlbumModal;
